import { SvgIcon, SvgIconProps } from "@mui/material";

export const SpeedometerIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M19.14 20.25C18.95 20.25 18.76 20.18 18.61 20.04C18.31 19.75 18.31 19.28 18.6 18.98C20.31 17.24 21.25 14.94 21.25 12.5C21.25 7.4 17.1 3.25 12 3.25C6.9 3.25 2.75 7.4 2.75 12.5C2.75 14.93 3.68 17.22 5.38 18.96C5.67 19.26 5.66 19.73 5.37 20.02C5.07 20.31 4.6 20.3 4.31 20.01C2.34 17.99 1.25 15.32 1.25 12.5C1.25 6.57 6.07 1.75 12 1.75C17.93 1.75 22.75 6.57 22.75 12.5C22.75 15.33 21.66 18.01 19.67 20.03C19.53 20.18 19.33 20.25 19.14 20.25Z"
      fill="#D97706"
    />
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M11.9999 22.25C9.72988 22.25 7.87988 20.4 7.87988 18.13C7.87988 15.86 9.72988 14 11.9999 14C14.2699 14 16.1199 15.85 16.1199 18.12C16.1199 20.39 14.2699 22.25 11.9999 22.25ZM11.9999 15.5C10.5499 15.5 9.37988 16.68 9.37988 18.12C9.37988 19.56 10.5599 20.74 11.9999 20.74C13.4399 20.74 14.6199 19.56 14.6199 18.12C14.6199 16.68 13.4499 15.5 11.9999 15.5Z"
      fill="#D97706"
    />
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M16 12.75H15.25C14.42 12.75 13.75 12.08 13.75 11.25V10.5C13.75 9.26 14.76 8.25 16 8.25C17.24 8.25 18.25 9.26 18.25 10.5C18.25 11.74 17.24 12.75 16 12.75ZM16 9.75C15.59 9.75 15.25 10.09 15.25 10.5V11.25H16C16.41 11.25 16.75 10.91 16.75 10.5C16.75 10.09 16.41 9.75 16 9.75Z"
      fill="#D97706"
    />
  </SvgIcon>
);
